"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationStats = void 0;
const OperationDuration_1 = require("./OperationDuration");
const OperationDecorator_1 = require("./OperationDecorator");
class OperationStats {
    static getTryCatchFinallyHook(_ctx) {
        throw new Error('OperationStats.getTryCatchFinallyHook is abstract and must be implemented by derived class');
    }
    getMetricName(ctx) {
        const opName = OperationDecorator_1.OperationDecorator.getOperationName(ctx);
        if (!opName)
            return undefined;
        switch (ctx.stage) {
            case 'try':
                return `${opName}.try`;
            case 'catch':
                return `${opName}.catch`;
            case 'finally':
            default:
                return `${opName}`;
        }
    }
    onTry(ctx) {
        ctx.tags = [];
        if (!ctx.sharedContext.tags)
            ctx.sharedContext.tags = [];
        return () => {
            const metricName = this.getMetricName(ctx);
            if (metricName)
                this.statsOperationEvent({
                    context: ctx,
                    event: 'try',
                    shouldStats: false,
                    stats: {
                        metric: metricName,
                        method: 'incr',
                        value: 1,
                        tags: this.mergeTags(ctx.sharedContext.tags, ctx.tags)
                    }
                });
        };
    }
    mergeTags(...args) {
        let [distinct, tagSets] = (typeof args[0] == 'boolean' ? args : [true, args]);
        tagSets = tagSets.filter((t) => (t && Array.isArray(t)) || t instanceof Object);
        if (!distinct)
            return tagSets.flatMap((t) => (Array.isArray(t) ? t : this.tagsMapToArray(t)));
        const allTagsMaps = tagSets.map((tags) => (!tags ? {} : Array.isArray(tags) ? this.tagsArrayToMap(tags) : tags));
        const tagsMap = Object.assign({}, ...allTagsMaps);
        return this.tagsMapToArray(tagsMap);
    }
    tagsMapToArray(tags) {
        return Object.entries(tags).map(([key, value]) => value === undefined || value === '' || value === null ? key : `${key}:${value}`);
    }
    tagsArrayToMap(tags) {
        const res = {};
        for (const tag of tags) {
            const sepIndex = tag.indexOf(':');
            const [key, value] = sepIndex >= 0 ? [tag.slice(0, sepIndex), tag.slice(sepIndex + 1)] : [tag, undefined];
            res[key] = value;
        }
        return res;
    }
    statsOperationEvent(args) {
        if (args.context.decoratorArgs?.shouldStats) {
            const shouldStats = args.context.decoratorArgs.shouldStats(args);
            if (shouldStats !== undefined)
                args.shouldStats = shouldStats;
        }
        if (args.shouldStats && args.stats) {
            this.stats(args.stats);
        }
    }
    onCatch(ctx) {
        const metricName = this.getMetricName(ctx);
        if (metricName)
            this.statsOperationEvent({
                context: ctx,
                event: ctx.stage,
                shouldStats: false,
                stats: {
                    metric: metricName,
                    method: 'incr',
                    value: 1,
                    tags: this.mergeTags(ctx.sharedContext.tags, ctx.tags)
                }
            });
    }
    onFinally(ctx) {
        const finallyTags = [];
        if (ctx.stage == 'finally')
            finallyTags.push(`error:${ctx.error ? 'true' : 'false'}`);
        if (ctx.error) {
            const error = ctx.error;
            finallyTags.push(...(this.extractTagsFromError(error, ctx) || []));
        }
        ctx.tags.push(...finallyTags);
        return () => {
            const finallyTags = this.mergeTags(ctx.sharedContext.tags, ctx.tags);
            const metricName = this.getMetricName(ctx);
            if (metricName)
                this.statsOperationEvent({
                    context: ctx,
                    event: 'finally',
                    shouldStats: true,
                    stats: { metric: metricName, method: 'incr', value: 1, tags: [...finallyTags] }
                });
            const duration = OperationDuration_1.OperationDuration.getDuration(ctx);
            const histogramMetric = this.getHistogramMetric(ctx);
            if (duration !== undefined && histogramMetric)
                this.statsOperationEvent({
                    context: ctx,
                    event: 'duration',
                    shouldStats: true,
                    stats: { metric: histogramMetric, method: 'histogram', value: duration, tags: [...finallyTags] }
                });
        };
    }
    getHistogramMetric(ctx) {
        const opName = OperationDecorator_1.OperationDecorator.getOperationName(ctx);
        if (!opName)
            return undefined;
        return `${opName}.duration`;
    }
    extractTagsFromError(error, ctx) {
        const res = [];
        const errorOperation = this.getErrorOperationNameTag(error, ctx);
        if (errorOperation)
            res.push(`error_operation:${errorOperation}`);
        res.push(`error_class:${error?.constructor?.name || typeof error}`);
        return res;
    }
    getErrorOperationNameTag(error, ctx) {
        const errorContext = error.trackedContext;
        return errorContext ? this.getOperationNameTag(errorContext) : this.getOperationNameTag(ctx);
    }
    getOperationNameTag(ctx) {
        return OperationDecorator_1.OperationDecorator.getOperationName(ctx);
    }
}
exports.OperationStats = OperationStats;
//# sourceMappingURL=OperationStats.js.map